const Device = () => import('./pages/Device.vue');
const Configuration = () => import('./pages/Configuration.vue');
const ShipayTransaction = () => import('./pages/Shipay/Transaction.vue');
const CheckoutConfiguration = () => import('./pages/Checkout/Configuration.vue');
const BeneficioFiscal = () => import('./modules/Beneficio/pages/BeneficioFiscal.vue');

export default [
  {
    path: '/fiscal/device',
    name: 'FiscalDevice',
    component: Device,
  },
  {
    path: '/fiscal/configuration',
    name: 'FiscalConfiguration',
    component: Configuration,
  },
  {
    path: '/fiscal/shipay-transaction',
    name: 'ShipayTransaction',
    component: ShipayTransaction,
  },
  {
    path: '/fiscal/checkout',
    name: 'FiscalCheckoutConfiguration',
    component: CheckoutConfiguration,
  },
  {
    path: '/fiscal/beneficio-fiscal',
    name: 'BeneficioFiscal',
    component: BeneficioFiscal,
  },
];
